export const INIT_PATIENTS = 'INIT_PATIENTS';

export const LIST_PATIENTS = 'LIST_PATIENTS';
export const LIST_PATIENTS_SUCCESS = 'LIST_PATIENTS_SUCCESS';
export const LIST_PATIENTS_FAILED = 'LIST_PATIENTS_FAILED';
